import { render, staticRenderFns } from "./VCustomIcon.vue?vue&type=template&id=7a8ec900&scoped=true"
import script from "./VCustomIcon.vue?vue&type=script&lang=js"
export * from "./VCustomIcon.vue?vue&type=script&lang=js"
import style0 from "./VCustomIcon.vue?vue&type=style&index=0&id=7a8ec900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ec900",
  null
  
)

export default component.exports